import Vue from "vue";
import Vuetify, {
  VCarousel,
  VCarouselItem,
  VDialog,
  VCard,
  VApp
} from "vuetify/lib";
//import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify, {
  components: {
    VCarousel,
    VCarouselItem,
    VDialog,
    VCard,
    VApp
  }
});

export default new Vuetify({
  theme: { disable: true }
});
